import { useRef } from 'react'
import { GeneralAPI } from '../../apis/GeneralAPI'
import { first } from 'lodash'
import Footer from '../../components/Footer'
import HeroBanner from '../../components/Podcasts/HeroBanner'
import GradientBox from '../../components/Backgrounds/GradientBox'
import SectionHeading from '../../components/HomePage/SectionHeading'
import SectionSubText from '../../components/HomePage/SectionSubText'
import ShallowHeader from '../../components/ShallowHeader'
import RightIcon from '../../Icons/coaching/funnel/right-icon.svg'
import GradientBorderBox from '../../components/Backgrounds/GradientBorderBox'
import PodcastsSlider from '../../components/Podcasts/PodcastsSlider'
import { PodCastAPI } from '../../apis/PodcastAPI'
import EmbedHubSpotForm from '../../components/EmbedHubSpotForm'
import PodcastsWithPagination from '../../components/Podcasts/PodcastsWithPagination'
const partners = [
    {
        name: 'Google Podcasts',
        logo: '/assets/podcasts/platforms/1.png',
        href: 'https://www.youtube.com/playlist?list=PLp7MsDxHLI98b1ghXxG2SwSSVXTL4mZPp',
    },
    {
        name: 'Spotify',
        logo: '/assets/podcasts/platforms/2.png',
        href: 'https://open.spotify.com/show/7p6bl0aaYp2RcihTR2KHlZ',
    },
    // {
    //     name: 'Apple Podcasts',
    //     logo: '/assets/podcasts/platforms/3.png',
    // },
    // {
    //     name: 'Stitcher',
    //     logo: '/assets/podcasts/platforms/4.png',
    // },
]

const subscriptionPlatforms = [
    // {
    //     name: 'Itunes',
    //     logo: '/assets/podcasts/platforms/1.svg',
    //     href:
    // },
    {
        name: 'Spotify',
        logo: '/assets/podcasts/platforms/2.svg',
        href: 'https://open.spotify.com/show/7p6bl0aaYp2RcihTR2KHlZ',
    },
    {
        name: 'Youtube',
        logo: '/assets/podcasts/platforms/youtube.svg',
        href: 'https://www.youtube.com/playlist?list=PLp7MsDxHLI98b1ghXxG2SwSSVXTL4mZPp',
    },
    // {
    //     name: 'Stitcher',
    //     logo: '/assets/podcasts/platforms/4.svg',
    // },
]

export function Podcasts({ podcasts, oldPodcasts, meta }) {
    // Pagination state
    const podcastsRef = useRef(null) // Create a reference for the podcast section

    // Function to handle page change and scroll to top
    const onPageChange = () => {
        podcastsRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <div>
            <ShallowHeader title={"Podcasts We're On"} meta={meta} />
            <div className="py-4">
                <HeroBanner />
            </div>
            <div className="bg-gray-50 py-20 space-y-8">
                <div className="text-center text-olm">Streaming Platforms</div>
                <div className="max-w-sm mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8 sm:gap-12 md:gap-16">
                    {partners.map((partner, idx) => (
                        <a
                            key={idx}
                            href={partner.href}
                            target="_blank"
                            className="flex justify-center items-center"
                            rel="noreferrer">
                            <img
                                src={partner.logo}
                                alt={partner.name}
                                className="max-w-full w-48 h-auto"
                            />
                        </a>
                    ))}
                </div>

                <GradientBox>
                    <div className="max-w-5xl m-auto text-center text-white">
                        <SectionHeading>
                            About Everything Direct to Seller Marketing Podcast
                        </SectionHeading>
                        <SectionSubText>
                            <div className="max-w-3xl m-auto">
                                Welcome to Everything Direct to Seller Marketing
                                with Justin Silverio! This podcast is your
                                ultimate resource for mastering direct-to-seller
                                marketing in real estate.
                            </div>
                        </SectionSubText>
                    </div>
                </GradientBox>
            </div>

            <div className="min-h-full" ref={podcastsRef}>
                <div className="bg-light-yellow-gradient-transparent">
                    <div className="container m-auto py-14 px-2 space-y-10">
                        {podcasts && (
                            <PodcastsWithPagination
                                podcasts={podcasts}
                                onPageChange={onPageChange}
                                title="EPISODES"
                            />
                        )}

                        <div className="my-48">
                            <div className="bg-ltr-gradient md:grid md:grid-cols-2 rounded-xl mt-28">
                                <div className="space-y-6 p-4 md:p-12 text-white text-left h-full">
                                    <SectionHeading>
                                        <p className="text-left">
                                            Subscribe AND GET FREE RESOURCES
                                        </p>
                                    </SectionHeading>
                                    <SectionSubText>
                                        <p className="text-xl">
                                            Sign up to receive our essential
                                            real estate investor resources for
                                            free. Here’s what you’ll get:
                                        </p>
                                    </SectionSubText>
                                    <div className="space-y-2 text-xl font-normal">
                                        {[
                                            'Business Setup Checklist',
                                            'Purchase Contract Template',
                                            'Recommended Prospect Lists',
                                            'Assignment Contract Template',
                                            'General List Criteria',
                                            'Agreement to Extend Closing Date',
                                            'FOIA Request Template',
                                            'Deal Analysis Tool',
                                            'Phone Scripts',
                                        ].map((item, index) => (
                                            <div
                                                key={index}
                                                className="flex items-center space-x-4">
                                                <RightIcon className="h-5 w-5" />
                                                <p>{item}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <GradientBorderBox className="h-full">
                                    <div className="p-4 md:py-0">
                                        <EmbedHubSpotForm
                                            portalId="21994206"
                                            formId="5fd6e2f8-70a3-40f9-af80-f395cd112b84"
                                            formName="Subscribe to Podcasts"
                                        />
                                    </div>
                                </GradientBorderBox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container m-auto my-40 space-y-20">
                <SectionHeading>
                    <p>
                        <span className="olm-gradient-text">OTHER PODCAST</span>{' '}
                        WE’RE ON
                    </p>
                </SectionHeading>
                <PodcastsSlider podcasts={oldPodcasts}></PodcastsSlider>
            </div>

            <div className="bg-light-yellow-gradient-transparent py-20 space-y-10">
                <SectionHeading>
                    <p>
                        <span className="olm-gradient-text">Subscribe</span> and
                        Follow
                    </p>
                </SectionHeading>

                <div className="grid grid-cols-2 md:grid-cols-2 px-4 gap-4 max-w-sm m-auto">
                    {subscriptionPlatforms.map((platform, idx) => (
                        <a
                            href={platform.href}
                            target="_blank"
                            key={idx}
                            className="flex items-center justify-center text-white bg-olh space-y-2 flex-col h-32 w-auto rounded-lg"
                            rel="noreferrer">
                            <img src={platform.logo} alt={platform.name} />
                            <span className="text-center uppercase font-semibold text-white">
                                {platform.name}
                            </span>
                        </a>
                    ))}
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Podcasts

// This function gets called at build time on server-side.
export async function getStaticProps() {
    let oldPodcasts = []
    const { yoast_head, acf } = first(
        await GeneralAPI.getPageBySlug('podcasts'),
    )

    const podcasts = await PodCastAPI.getAllInOneShot()

    if (acf?.podcasts?.length > 0) {
        oldPodcasts = acf?.podcasts
    }

    return {
        props: {
            data: {},
            podcasts,
            oldPodcasts: oldPodcasts,
            meta: yoast_head,
        },
        revalidate: 10, // In seconds
    }
}
